import Vue from 'vue'
import Router from 'vue-router'
// import PurchaseRecords from '@/viewa/mine/PurchaseRecords'
// import ConsumeRecords from '@/viewa/mine/ConsumeRecords'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{ //测试
    path: '/test',
    name: 'Test',
    component: resolve => require(['@/views/test/test'], resolve),
    meta: {
      title: '购买记录',
    }
  },
  {
    path: '/mine',
    name: 'Mine',
    component: resolve => require(['@/views/publicNum/Mine'], resolve),
    meta: {
      title: '我的账户',
    }
  },
  { //购买记录
    path: '/buyRecords',
    name: 'BuyRecords',
    component: resolve => require(['@/views/publicNum/BuyRecords'], resolve),
    meta: {
      title: '购买记录',
    }
  },
  { //消费记录
    path: '/consumeRecords',
    name: 'ConsumeRecords',
    component: resolve => require(['@/views/publicNum/ConsumeRecords'], resolve),
    meta: {
      title: '消费记录',
    }
  },
  { //套餐
    path: '/package',
    name: 'Package',
    component: resolve => require(['@/views/publicNum/Package'], resolve),
    meta: {
      title: '新100畅享套餐',
    }
  },
  { //积赞
    path: '/praise',
    name: 'Praise',
    component: resolve => require(['@/views/publicNum/Praise'], resolve),
    meta: {
      title: '积赞有礼',
    }
  },
  { // 绑定
    path: '/binding',
    name: 'Binding',
    component: resolve => require(['@/views/publicNum/Binding'], resolve),
    meta: {
      title: '绑定有礼',
    }
  },
  { //购买
    path: '/purchase',
    name: 'Purchase',
    component: resolve => require(['@/views/publicNum/Purchase'], resolve),
    meta: {
      title: '订购套餐',
    }
  },


  { //支付结果
    path: '/payStatus',
    name: 'PayStatus',
    component: resolve => require(['@/views/publicNum/PayStatus'], resolve),
    meta: {
      title: '支付结果',
    }
  },

  { //常见问题
    path: '/HXTFAQ',
    name: 'HXTFAQ',
    component: resolve => require(['@/views/hxtfaq/FAQ'], resolve),
    meta: {
      title: '常见问题',
    }
  },
  { //常见问题
    path: '/HXTFAQCont',
    name: 'HXTFAQCont',
    component: resolve => require(['@/views/hxtfaq/FAQCont'], resolve),
    meta: {
      title: '常见问题',
    }
  },

  { //常见问题
    path: '/FAQ',
    name: 'FAQ',
    component: resolve => require(['@/views/publicNum/FAQ'], resolve),
    meta: {
      title: '常见问题',
    }
  },
  { //常见问题
    path: '/FAQCont',
    name: 'FAQCont',
    component: resolve => require(['@/views/publicNum/FAQCont'], resolve),
    meta: {
      title: '常见问题',
    }
  },
  { //登录
    path: '/login',
    name: 'Login',
    component: resolve => require(['@/views/publicNum/Login'], resolve),
    meta: {
      title: '号码绑定',
    }
  },

  // app外链
  {
    path: '/information',
    name: 'Information',
    // component: Information,
    component: resolve => require(['@/views/app/Information'], resolve),
    meta: {
      title: '业务资讯',
    }
  },
  {
    path: '/inviteGift',
    name: 'InviteGift',
    // component: InviteGift,
    component: resolve => require(['@/views/app/InviteGift'], resolve),
    meta: {
      title: '邀请有礼',
    }
  },
  {
    path: '/inviteLogin',
    name: 'InviteLogin',
    // component: InviteLogin,
    component: resolve => require(['@/views/app/InviteLogin'], resolve),
    meta: {
      title: '注册有礼',
    }
  },
  {
    path: '/PurchaseSpecification',
    name: 'PurchaseSpecification',
    // component: PurchaseSpecification,
    component: resolve => require(['@/views/app/PurchaseSpecification'], resolve),
    meta: {
      title: '购买套餐说明',
    }
  },
  // 江苏卫星宽带隐私政策、使用条款
  {
    path: '/jswxpro/privacyPolicy',
    name: 'PrivacyPolicy',
    // component: PrivacyPolicy,
    component: resolve => require(['@/views/app/jswxpro/PrivacyPolicy'], resolve),
    meta: {
      title: '隐私政策',
    }
  },
  {
    path: '/jswxpro/yxtTOS',
    name: 'YxtTOS',
    // component: YxtTOS,
    component: resolve => require(['@/views/app/jswxpro/YxtTOS'], resolve),
    meta: {
      title: '使用条款',
    }
  },
  {
    path: '/jswxpro/ios_personal',
    name: 'ios_personal',
    // component: YxtTOS,
    component: resolve => require(['@/views/app/jswxpro/ios_personal'], resolve),
    meta: {
      title: '个人信息收集清单',
    }
  },
  {
    path: '/jswxpro/ios_tripartite',
    name: 'ios_tripartite',
    // component: YxtTOS,
    component: resolve => require(['@/views/app/jswxpro/ios_tripartite'], resolve),
    meta: {
      title: '第三方个人信息共享清单',
    }
  },


  {
    path: '/jswxpro/PrivacyPolicy_maritime',
    name: 'PrivacyPolicy_maritime',
    // component: YxtTOS,
    component: resolve => require(['@/views/app/jswxpro/PrivacyPolicy_maritime'], resolve),
    meta: {
      title: '隐私政策',
    }
  },

  // 渔汛通新增应用内容
  // {
  //   path: '/jswxpro/yxtAppContent',
  //   name: 'yxtAppContent',
  //   component: resolve => require(['@/views/app/jswxpro/yxtAppContent'], resolve),
  //   meta: {
  //     title: '应用内容',
  //   }
  // },
  {
    path: '/jswxpro/YxtTOS_maritime',
    name: 'YxtTOS_maritime',
    // component: YxtTOS,
    component: resolve => require(['@/views/app/jswxpro/YxtTOS_maritime'], resolve),
    meta: {
      title: '使用条款',
    }
  },

  // 第三方信息共享清单
  {
    path: '/jswxpro/ThirdInformation',
    name: 'ThirdInformation',
    // component: YxtTOS,
    component: resolve => require(['@/views/app/jswxpro/list_third_information_shar'], resolve),
    meta: {
      title: '第三方信息共享清单',
    }
  },
  // 个人信息明示清单
  {
    path: '/jswxpro/PersonalInformation',
    name: 'PersonalInformation',
    // component: YxtTOS,
    component: resolve => require(['@/views/app/jswxpro/list_personal_information'], resolve),
    meta: {
      title: '个人信息明示清单',
    }
  },


  // 江苏卫星宽带隐私政策、使用条款


  {
    path: '/protocol/TOS',
    name: 'TOS',
    // component: TOS,
    component: resolve => require(['@/views/app/protocol/TOS'], resolve),
    meta: {
      title: '服务协议',
    }
  },

  {
    path: '/protocol/privacyPolicy',
    name: 'PrivacyPolicy',
    // component: PrivacyPolicy,
    component: resolve => require(['@/views/app/protocol/PrivacyPolicy'], resolve),
    meta: {
      title: '隐私声明',
    }
    },
  
    // 华侨通新增应用内容
    {
      path: '/protocol/hqtAppContent',
      name: 'hqtAppContent',
      component: resolve => require(['@/views/app/protocol/hqtAppContent'], resolve),
      meta: {
        title: '应用内容',
      }
    },
  {
    path: '/protocol/collectionList',
    name: 'CollectionList',
    component: resolve => require(['@/views/app/protocol/CollectionList'], resolve),
    meta: {
      title: '个人信息收集清单',
    }
  }, ,
  {
    path: '/protocol/shareList',
    name: 'ShareList',
    // component: PrivacyPolicy,
    component: resolve => require(['@/views/app/protocol/ShareList'], resolve),
    meta: {
      title: '第三方个人信息共享清单',
    }
  }, ,
  {
    path: '/protocol/yxtTOS',
    name: 'YxtTOS',
    // component: YxtTOS,
    component: resolve => require(['@/views/app/protocol/YxtTOS'], resolve),
    meta: {
      title: '渔汛通服务协议',
    }
  },
  {
    path: '/protocol/yxtPrivacyPolicy',
    name: 'YxtPrivacyPolicy',
    // component: YxtPrivacyPolicy,
    component: resolve => require(['@/views/app/protocol/YxtPrivacyPolicy'], resolve),
    meta: {
      title: '渔汛通隐私条款',
    }
  },
  {
    path: '/christmasActive',
    name: 'ChristmasActive',
    // component: ChristmasActive,
    component: resolve => require(['@/views/app/christmasActive'], resolve),
    meta: {
      title: '圣诞节活动',
    }
  },
  {
    path: '/active/Annual',
    name: 'Annual',
    // component: Annual, /active/Annual?phoneNumber='2ee90ff0be7049318cdd59923610676e',
    component: resolve => require(['@/views/app/active/Annual'], resolve),
    meta: {
      title: '年度账单',
    }
  },
  {
    path: '/active/NewYear',
    name: 'NewYear',
    component: resolve => require(['@/views/app/active/NewYear'], resolve),
    meta: {
      title: '新年活动',
    }
  },
  //年终钜惠活动
  {
    path: '/newYearActive',
    name: 'NewYearActive',
    component: resolve => require(['@/views/publicNum/NewYearActive.vue'], resolve),
    meta: {
      title: '钜惠套餐',
    }
  },


  {
    path: '/openApp',
    name: 'OpenApp',
    component: resolve => require(['@/views/app/openApp'], resolve),
    meta: {
      title: '华侨通',
    }
  },
  {
    path: '*',
    redirect: '/mine'
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js